/**
 * Utility functions for detecting if the current session is a Playwright test
 */

/**
 * Detects if the current session is running in Playwright
 * @returns true if running in Playwright, false otherwise
 */
export const isPlaywrightTest = (): boolean => {
  const userAgent = navigator.userAgent || ''

  if (
    userAgent.includes('Playwright') ||
    userAgent.includes('HeadlessChrome')
  ) {
    return true
  }

  const windowAny = window as any
  // eslint-disable-next-line no-underscore-dangle
  if (windowAny.playwright || windowAny.__playwright || windowAny.__PW_TEST__) {
    return true
  }

  if (navigator.webdriver === true) {
    return true
  }

  return false
}
